import React, {Component} from 'react';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import env from '../../env';
import './style.css';
import {get} from "axios";

class OnlineAttendanceInfo extends Component {

    total = 0;
    countParticipants = 0;
    countAbsent = 0;
    countMale = 0;
    countFemale = 0;
    eventId = 0;
    stompClient;
    serverUrl = env.wsURL;
    participants = [];
    lastParticipant = {};
    selectedUnitIds = [];

    componentWillMount() {
        let root = document.documentElement;
        const bg = 'url("' + env.s3url + '/files/background/' + localStorage.getItem('tenantId') + '.png")';
        root.style.setProperty('--url-bg', bg)
        this.eventId = this.props.match.params.eventId;

        this.getUnitsOfEvent().then(rs => {
            if (rs.data) {
                for (let i = 0; i < rs.data.length; i++) {
                    const unit = rs.data[i];
                    this.selectedUnitIds.push(unit.id);
                }
            }
            this.openWS();
        });
    }

    getUnitsOfEvent() {
        const url = `${env.baseURL}/api/units/getUnitsOfEvent?eventId=` + this.eventId;
        return get(url, this.getConfig());
    }

    openWS() {
        const token = localStorage.getItem('token');
        const config = this.getConfig();
        const socket = new SockJS(
            `${this.serverUrl}?token=${encodeURIComponent(token)}`
        );
        this.stompClient = Stomp.over(socket);
        this.stompClient.debug = null;
        const that = this;
        this.stompClient.connect({
            name: this.eventId,
            Authorization: token
        }, function (frame) {
            that.stompClient.send('/app/getRecentlyAttendanceInfo', config, JSON.stringify({
                'eventId': that.eventId,
                'unitIds': that.selectedUnitIds
            }));
            that.stompClient.subscribe('/user/queue/returnRecentlyAttendanceInfo', message => {
                that.lastParticipant = null;
                that.forceUpdate();
                if (message.body) {
                    const attendanceInfo = JSON.parse(message.body);
                    const newParticipants = attendanceInfo.newParticipants;
                    if (newParticipants.length > 0) {
                        that.lastParticipant = newParticipants[newParticipants.length - 1];
                    }
                    that.forceUpdate()
                }
            }, {Authorization: token});
        });
    }

    getConfig() {
        const token = localStorage.getItem('token');
        const config = {
            headers: {
                'content-type': 'application/json',
                'Authorization': token
            }
        };
        return config;
    }

    getWelcomeNameFontSize() {
        const fullNameLength = this.lastParticipant?.fullName?.length ?? 0;

        if (fullNameLength > 14) {
            return '30pt';
        }

        return '40pt';
    }


    render() {
        return (
            <div className="bodyDivV3">
                <div className="text-container">
                    <span className='welcomeName' style={{fontSize: this.getWelcomeNameFontSize()}}>
                        {this.lastParticipant?.fullName ?? ''}
                    </span>
                </div>
                <div className="image-container">
                    <div className="imageWrapper">
                        {this.lastParticipant?.photoName &&
                            <img className='imgStyle'
                                 src={`${env.s3url}${this.lastParticipant?.photoName}`}
                                 alt=""
                            />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default OnlineAttendanceInfo

